<template>
  <div data-app>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" sm="6" md="6" style="color: #e33354" class="ml-4">
            <h3>{{ cardTitle }}</h3>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="3" md="3">
            <v-text-field
              v-model="search"
              append-icon="search"
              :label="$t('FORMS.search')"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="bannerCollection"
          :search="search"
          :sort-by="['id']"
          sort-desc="true"
          :loading="loadingTable"
          @click:row="handleClickItem"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <BannerModalForm
                :modalData="modalData"
                :permissions="permissions"
                :statuses="statuses"
                :endPoint="endPoint"
                @closeModalForm="handleCloseModalForm"
                @saveModalForm="handleSaveModalForm"
                @new="handleNew"
              ></BannerModalForm>
              <v-spacer></v-spacer>
              <DeleteModalDialog
                :dialogDelete="dialogDelete"
                @closeDelete="handleCloseDelete"
                @deleteItemConfirm="handleDeleteItemConfirm"
              >
              </DeleteModalDialog>
            </v-toolbar>
          </template>
          <template v-slot:item.translated="{ item }">
            <v-icon v-if="item.translated" color="green" small
              >check_circle</v-icon
            >
          </template>

          <template v-slot:item.banner_client_id="{ item }">
            {{ getBannerClientName(item.banner_client_id) }}
          </template>

          <template v-slot:item.banner_campaign_id="{ item }">
            {{ getBannerCampaignName(item.banner_campaign_id) }}
          </template>

          <template v-slot:item.bannerType="{ item }">
            <span>{{ getBannerName(item.type) }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <span v-if="+item.status == 1">active</span>
            <span v-else>inactive</span>
          </template>
          <template v-slot:item.in_admin_lists="{ item }">
            <span v-if="+item.in_admin_lists == 1">igen</span>
            <span v-else>nem</span>
          </template>  
          <template v-slot:item.actions="{ item }">
            <v-icon
              color="primary"
              v-if="permissionCan('delete')"
              small
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SiteService from "@/core/services/site.service.js";

import { listModelsMixins } from "@/view/mixins/listModelsMixins.js";

import BannerModalForm, { initialFormData } from "./BannerModalForm";

import DeleteModalDialog from "@/view/components/DeleteModalDialog";

export const PERMISSION_TO = "pages.banner.";

export default {
  name: "Banners",
  components: { BannerModalForm, DeleteModalDialog },
  mixins: [listModelsMixins],
  data() {
    return {
      cardTitle: this.$t("MENU.banners"),
      search: "",
      routePath: "/cms/banners/banners/",
      permissionTo: PERMISSION_TO,
      permissions: JSON.parse(localStorage.permissions),
      headers: [
        // {
        //   text: this.$t("TABLE.translated"),
        //   value: "translated",
        //   width: "100px",
        // },
        {
          text: this.$t("FORM_INPUT_NAMES.name"),
          value: "name",
        },
        {
          text: this.$t("TABLE.client"),
          value: "banner_client_id",
        },
        {
          text: this.$t("TABLE.campaign"),
          value: "banner_campaign_id",
        },
        { text: this.$t("TABLE.type"), value: "bannerType" },
        { text: this.$t("TABLE.status"), value: "status" },
        { text: this.$t("TABLE.in_admin_lists"), value: "in_admin_lists" },
        {
          text: this.$t("TABLE.actions"),
          value: "actions",
          sortable: false,
          width: "100px",
        },
      ],

      modalData: {
        dialog: false,
        editedId: null,
      },
      editedItem: Object.assign({}, initialFormData()),

      dialogDelete: false,
    };
  },

  computed: {
    ...mapGetters([
      "bannerCollection",
      "statuses",
      "getBannerCampaignByID",
      "getBannerClientByID",
    ]),

    endPoint() {
      return "pages/admin/" + SiteService.getActiveSiteId() + "/banner/";
    },
  },

  watch: {
    dialogDelete(val) {
      val || this.handleCloseDelete();
    },
    "$route.params.id": {
      handler: function (id) {
        if (id) {
          this.editItem(id);
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    ...mapActions(["fetchBanner"]),

    bannerTypes() {
      let config_banner_types = this.$store.getters.types.banner.banner_type;
      let bannerTypes = [];
      config_banner_types.forEach((item) => {
        bannerTypes.push({
          id: item.value,
          text: this.$t("BANNER_TYPES." + item.value),
        });
      });
      return bannerTypes;
    },

    fetchModel() {
      return this.fetchBanner();
    },
    getBannerCampaignName(banner_campaign_id) {
      let banner_campaign = this.getBannerCampaignByID(banner_campaign_id);
      if (banner_campaign) {
        return banner_campaign.name;
      }
      return "";
    },
    getBannerClientName(banner_client_id) {
      let banner_client = this.getBannerClientByID(banner_client_id);
      if (banner_client) {
        return banner_client.name;
      }
      return "";
    },

    getBannerName(id) {
      let bannerTypes = this.bannerTypes();
      if (!bannerTypes) {
        return null;
      }
      return bannerTypes.find((i) => i.id == id).text;
    },
  },

  mounted() {
    this.loadingTable = true;
    this.fetchModel().then(() => (this.loadingTable = false));
  },
};
</script>
